import React from 'react';
import { FsRadioGroup, FsRadio } from '@finalsite/wc-react';

const convertToBool = (value) => {
  if (value === true || value === 'true' || 'yes' === value || 'Yes' === value) {
    return true;
  } else if (value === false || value === 'false' || 'no' === value || 'No' === value) {
    return false;
  }
  return null;
}

export const BooleanField = ({ field, name, id, onChange }) => {
  return <FsRadioGroup id={id}
                       name={name}
                       label={field.rendered_prompt}
                       required={field.required_on_form || field.has_required_children}
                       description={field.rendered_explanation}
                       hint={field.rendered_explanation}
                       {...{ onChange }}
  >
    <FsRadio value={'true'} checked={convertToBool(field.value) === true}>
      Yes
    </FsRadio>
    <FsRadio value={'false'} checked={convertToBool(field.value) === false}>
      No
    </FsRadio>
    <slot slot="hint">
      {field.rendered_explanation}
    </slot>
  </FsRadioGroup>
};
